export const tooltipSlotsTextColor = "#fff";
export const tooltipSlotsTextWidth = "fit-content";
export const tooltipSlotsTextTypography = "400 0.875rem/1.25rem Inter";
export const tooltipSlotsTextFontWeight = "500";
export const tooltipSlotsTextTextOverflow = "ellipsis";
export const tooltipSlotsBaseSurface = "#000";
export const tooltipSlotsBaseBorderRadius = "0.5rem";
export const tooltipSlotsBaseMaxWidth = "24rem";
export const tooltipSlotsBasePx = "0.75rem"; // this is for the popper.js offset
export const tooltipSlotsBasePy = "0.5rem"; // this is for the popper.js offset
export const tooltipSlotsBaseOffset = "0.25rem"; // this is for the popper.js offset
export const tooltipSlotsBaseBoxShadow = "0 0.063rem 0.125rem 0 rgba(0,0,0,0.05)";
